import ApiService from '@/services/api';

const API = new ApiService();

export const state = {
    campaign: {},
    campaignList: [],
    campaignsTotal: 0,
    collateralsList: [],
    collateralsTotal: 0,
    error: null
}

export const mutations = {
    UPDATE_CAMPAIGN(state, list){
        state.campaign = list;
    },
    UPDATE_CAMPAIGN_LIST(state, list){
        state.campaignList = list;
    },
    UPDATE_CAMPAIGN_TOTAL(state, total){
        state.campaignsTotal = total;
    },
    UPDATE_COLLATERAL_LIST(state, list){
        state.collateralsList = list;
    },
    UPDATE_COLLATERAL_TOTAL(state, total){
        state.collateralsTotal = total;
    },
    SET_ERROR(state, error){
        state.error = error
    },
}

export const actions = {
    async getCampaignList({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/campaign/list-campaigns', params)
            .then(res => {
              commit('UPDATE_CAMPAIGN_LIST', res.message.rows);
              commit('UPDATE_CAMPAIGN_TOTAL', res.message.pageInfo.total);
              resolve(res)
            })
            .catch(err => reject(err));
        });
    },

    async getCampaign({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/campaign/get-campaign', params)
            .then(res => {
              commit('UPDATE_CAMPAIGN', res.message.row[0]);
              resolve(res)
            })
            .catch(err => reject(err));
        });
    },

    async createCampaign({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/campaign/create-campaign', params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
                commit('SET_ERROR', err)
                reject(err)
            });
        });
    },

    async updateCampaign({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/campaign/update-campaign', params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
                commit('SET_ERROR', err)
                reject(err)
            });
        });
    },

    async deleteCampaign({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/campaign/delete-campaign', params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
                commit('SET_ERROR', err)
                reject(err)
            });
        });
    },

    async getCollateralList({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/campaign/list-collaterals', params)
            .then(res => {
              commit('UPDATE_COLLATERAL_LIST', res.message.rows);
              commit('UPDATE_COLLATERAL_TOTAL', res.message.pageInfo.total);
              resolve(res)
            })
            .catch(err => reject(err));
        });
    },
}